import type { WorkItemDto } from '@customTypes/types';

import { SendWorkRequestView } from './SendWorkRequestView';
import { useSendWorkRequestView } from './useSendWorkRequestView';

export const SendWorkRequestContainer = ({
  clubId,
  artistId,
  workItem
}: {
  clubId: string;
  artistId: string;
  workItem: WorkItemDto | null;
}) => {
  const {
    state: { canSendRequest, cause },
    functions: { deleteRequest }
  } = useSendWorkRequestView({ artistId, workItem, clubId });

  return (
    <SendWorkRequestView
      artistId={artistId}
      canSendRequest={canSendRequest}
      cause={cause}
      clubId={clubId}
      deleteRequest={deleteRequest}
    />
  );
};
